export function navigateToDashboardHref(href: string) {
  window.location.assign(href);
}
